<template>
  <!-- ML -->
  <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]">
    <div data-template="template1" class="wrap-template template1">
      <div class="main-handicap m-hdp">
        <div class="vrow items-center template-title is_fold">
          <div class="play-name col" @click="showLeg()">
            <span class="ellipsis">
              {{ getTitleCaption() }}
            </span>
          </div>
          <div style="width: 37px;" @click="setToTop($event)">
            <span class="set_top" style="display: none;">
              <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"> </i>
            </span>
          </div>
        </div>
        <template v-if="show">
          <div class="handicap">
            <div class="handicap-item os-1">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item">
                      <div class="item-label bet-ellipsis ellipsis" style="width:70%">
                        <span class="ellipsis-wrap" v-html="newAllBetEvent.tacapt"></span>
                      </div>
                    </div>
                  </div>
                  <odd1x2 :event="newAllBetEvent" :team="teamHome" :plyType="plytyp" :betType="bettyp" ref="team1"
                    :mode="'ab'" />
                </div>
              </div>
            </div>
            <div class="handicap-item os-1">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item">
                      <div class="item-label bet-ellipsis ellipsis" style="width:70%">
                        <span class="ellipsis-wrap" v-html="newAllBetEvent.tbcapt"></span>
                      </div>
                    </div>
                  </div>
                  <odd1x2 :event="newAllBetEvent" :team="teamAway" :plyType="plytyp" :betType="bettyp" ref="teamX"
                    :mode="'ab'" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import Odd1x2Components from '../../../components/odd1x2'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      btypes: [allBetMixin.data().onex2BetType, allBetMixin.data().ronex2BetType],
      show: true,
      shdp: ['7', '8', '9', '10', '11', '12'],
      gamePt: ['14', '15', '16', '17', '18'],  //game 1-5 playtype
      pt: {
        7: '1',
        8: '2',
        9: '3',
        10: '4',
        11: '5',
        12: '6',
      },
      gamePtLang: {
        '14': '1',
        '15': '2',
        '16': '3',
        '17': '4',
        '18': '5',
      }
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption() {
      var a = ''
      var pt = ''
      var bt = ''
      if (this.plytyp == this.ftPlyType) {
        a = '_FT'
      } else if (this.plytyp == this.firstHtPlyType) {
        a = '_1H'
      } else if (this.plytyp == this.gameHdpPlyType) {
        a = '_GAME_HDP'
      } else if (this.plytyp == this.setHandicapPlyType) {
        a = '_SET_HDP'
      } else if (this.plytyp == this.pointHdpPlyType) {
        a = '_POINT_HDP'
      } else if (jQuery.inArray(this.plytyp, this.shdp) != '-1') {  /*** Set ***/
        a = '_' + this.pt[this.plytyp] + 'SET'
      } else if (jQuery.inArray(this.plytyp, this.gamePt) != '-1') {  /*** Game ***/
        a = '_' + this.gamePtLang[this.plytyp] + 'GAME'
      }

      // Play Type
      pt = this.sportAllBetLang['ALL_BET.SUBHEADER' + a]

      // Bet Type
      bt = this.sportAllBetLang['ALL_BET.SUBHEADER_ML']

      return pt + bt
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, onex2BetType) {
      if (this.selectMarket)
        this.selectMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, onex2BetType) {
      if (this.removeMarket)
        this.removeMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial)
    },
    // oddsHeader(onex2BetType) {
    //   var retCapt = ''
    //   if (this.isSpecial) {
    //     retCapt += this.specialLeagueCaption(this.allBetEvent, onex2BetType)
    //   }
    //   return retCapt
    // },
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-ml.vue